import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, ScreenDepth } from "@ryde/theme";

export const AreaAdditionsTemplateWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "area-additions-template-wrapper",
  },
)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  border: 1px dashed ${greyMui._400};
  border-radius: 5px;
  padding: 12px;

  .area-additions__container {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .display-mode {
      transition: filter 0.55s ease-out;
    }

    &[data-inner-editing="true"] {
      .display-mode {
        filter: blur(3px) grayscale(100%) !important;
        pointer-events: none !important;
        transition: filter 0.55s ease-out;
      }

      .add_item_button_wrapper .MuiButton-root {
        filter: blur(3px) grayscale(100%);
        pointer-events: none;
        transition: filter 0.55s ease-out;
      }
    }
  }

  .add_item_button_wrapper {
    height: 30px;
    display: flex;
  }
`;

export const AreaAdditionDisplayItemStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "area-addition-display-item",
  },
)`
  display: grid;
  grid-template-columns: 120px 50px 1fr 80px;
  align-items: center;
  border: 1px solid ${greyMui._200};
  border-radius: 5px;
  padding: 6px;
`;

export const AreaAdditionEditItemStyled = styled.div.attrs<IStyledAttributes>(
  () => ({
    [DATA_E2E_KEY]: "area-addition-edit-item",
    className: "no-blur-item",
  }),
)`
  position: relative;
  z-index: ${ScreenDepth.INNER_ITEM_EDIT};
  filter: none;
  backdrop-filter: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  border: 1px solid ${greyMui._200};
  padding: 10px;
  border-radius: 5px;
  .buttons_edit_view {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
`;
